import { Skeleton } from "@arcadeai/design-system/components/ui/atoms/skeleton";

export function MyInvitationsSkeleton() {
  return (
    <div className="flex flex-col gap-4">
      {/* Header Section - matches ListLayout */}
      <div className="flex items-center justify-between">
        <div className="flex flex-col gap-2">
          <Skeleton className="h-8 w-48" />
          <Skeleton className="h-4 w-72" />
        </div>
      </div>

      {/* DataTable structure */}
      <div className="space-y-4">
        {/* Table */}
        <div className="rounded-md border">
          {/* Table Header */}
          <div className="flex items-center gap-4 border-b bg-muted/50 p-4">
            <Skeleton className="h-4 w-20" />
            <Skeleton className="hidden h-4 w-24 md:block" />
            <Skeleton className="hidden h-4 w-20 lg:block" />
            <Skeleton className="hidden h-4 w-16 sm:block" />
            <Skeleton className="ml-auto h-4 w-16" />
          </div>
          {/* Table Rows */}
          {[1, 2, 3, 4, 5].map((i) => (
            <div
              className="flex items-center gap-4 border-b p-4 last:border-b-0"
              key={i}
            >
              {/* Project */}
              <div className="flex flex-1 items-center gap-3">
                <Skeleton className="h-9 w-9 rounded-lg" />
                <div className="space-y-1.5">
                  <Skeleton className="h-4 w-28" />
                  <Skeleton className="h-3 w-20 md:hidden" />
                </div>
              </div>

              {/* Organization */}
              <Skeleton className="hidden h-4 w-24 md:block" />

              {/* Invited by */}
              <div className="hidden flex-1 items-center gap-2 lg:flex">
                <div className="flex -space-x-1">
                  <Skeleton className="h-7 w-7 rounded-full" />
                  <Skeleton className="h-7 w-7 rounded-full" />
                </div>
                <Skeleton className="h-4 w-20" />
              </div>

              {/* Expires */}
              <Skeleton className="hidden h-4 w-20 sm:block" />

              {/* Actions */}
              <div className="flex items-center justify-end gap-2">
                <Skeleton className="h-8 w-20" />
                <Skeleton className="h-8 w-20" />
                <Skeleton className="h-8 w-28" />
              </div>
            </div>
          ))}
        </div>

        {/* Pagination */}
        <div className="flex items-center justify-between gap-4 px-2">
          <div className="flex items-center space-x-2">
            <Skeleton className="h-4 w-24" />
            <Skeleton className="h-8 w-[70px]" />
          </div>
          <div className="flex items-center space-x-6">
            <Skeleton className="h-4 w-24" />
            <div className="flex items-center space-x-2">
              <Skeleton className="hidden h-8 w-8 lg:block" />
              <Skeleton className="h-8 w-8" />
              <Skeleton className="h-8 w-8" />
              <Skeleton className="hidden h-8 w-8 lg:block" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
